import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Illustration, Text, Title } from "@src/appV2/redesign/system/ui-components";
import { differenceInDays, parseISO } from "date-fns";

import { formatOrientationDateTime } from "../../utils";

interface Props {
  scheduledFor?: string;
  retakeAllowedAfter?: string;
  onBack: () => void;
}

export function ClipboardOrientationFailed(props: Props) {
  const { scheduledFor, retakeAllowedAfter, onBack } = props;

  const scheduledForString = isDefined(scheduledFor) ? formatOrientationDateTime(scheduledFor) : "";

  const daysUntilRetake = isDefined(retakeAllowedAfter)
    ? differenceInDays(parseISO(retakeAllowedAfter), new Date())
    : 0;

  const daysUntilRetakeString = daysUntilRetake > 0 ? `${daysUntilRetake} days, ` : "";

  const retakeAllowedAfterString = isDefined(retakeAllowedAfter)
    ? formatOrientationDateTime(retakeAllowedAfter, { roundTime: true })
    : "";

  return (
    <Stack justifyContent="space-between" height="100%" spacing={4}>
      <Stack alignItems="center" spacing={8} flex={1} px={6} pt={12}>
        <Illustration type="error" />
        <Stack spacing={6}>
          <Title variant="h3" component="h2" align="center">
            You missed your Demo Shift
          </Title>
          <Text
            light
            align="center"
            sx={{
              lineHeight: 1.25,
            }}
          >
            You missed the Demo Shift you scheduled {scheduledForString}. You can come back here to
            reschedule after {daysUntilRetakeString}
            {retakeAllowedAfterString}.
          </Text>
        </Stack>
      </Stack>

      <Button onClick={onBack}>Go Back</Button>
    </Stack>
  );
}
